// Depth for damage text/status labels: above everything else (highest possible depth)
const DAMAGE_TEXT_DEPTH = Number.MAX_SAFE_INTEGER + 100;
import Phaser from "phaser";

interface DamageTextPhaser {
  textObj: Phaser.GameObjects.Text;
  startY: number;
  startTime: number;
}

const DAMAGE_TEXT_DURATION = 2000; // ms
const DAMAGE_TEXT_SPEED = -32; // px over duration
let activeDamageTexts: DamageTextPhaser[] = [];

export function spawnDamageText(
  value: number,
  x: number,
  y: number,
  scene?: Phaser.Scene
) {
  spawnPlayerLabel(value, x, y, scene, "#ffffff");
}

export function spawnPlayerLabel(
  value: number | string,
  x: number,
  y: number,
  scene?: Phaser.Scene,
  color: string = "#ffffff"
) {
  if (!scene) {
    console.warn("spawnPlayerLabel: No scene provided");
    return;
  }

  if (!scene.add) {
    console.warn(
      "spawnPlayerLabel: Scene does not have add property (scene may be destroyed or invalid)"
    );
    return;
  }

  if (scene.add === null) {
    console.warn(
      "spawnPlayerLabel: Scene.add is null (scene may be destroyed or invalid)"
    );
    return;
  }

  if (!scene.time) {
    console.warn(
      "spawnPlayerLabel: Scene does not have time property (scene may be destroyed or invalid)"
    );
    return;
  } // Defer text creation to next frame to ensure scene is fully ready
  scene.time.delayedCall(1, () => {
    try {
      if (!scene.add || !scene.time) {
        console.warn("Scene became invalid during delayed call");
        return;
      }

      const textObj = scene.add
        .text(x, y, value.toString(), {
          font: "bold 20px Anton",
          color,
          stroke: "#000",
          strokeThickness: 2,
        })
        .setOrigin(0.5);
      textObj.setDepth(Number.MAX_SAFE_INTEGER); // Render at highest depth above everything else

      // Make sure UI camera ignores this text (game world element)
      if ((scene as any).uiCamera) {
        (scene as any).uiCamera.ignore(textObj);
      }

      activeDamageTexts.push({ textObj, startY: y, startTime: scene.time.now });
    } catch (error) {
      console.error("Error creating text object in delayed call:", error);
    }
  });
}

export function updateDamageTexts(scene: Phaser.Scene) {
  const now = scene.time.now;
  activeDamageTexts = activeDamageTexts.filter((dt) => {
    const elapsed = now - dt.startTime;
    if (elapsed > DAMAGE_TEXT_DURATION) {
      dt.textObj.destroy();
      return false;
    }
    // Animate upwards and fade out
    dt.textObj.y =
      dt.startY + DAMAGE_TEXT_SPEED * (elapsed / DAMAGE_TEXT_DURATION);
    dt.textObj.setAlpha(1 - elapsed / DAMAGE_TEXT_DURATION);
    return true;
  });
}

/**
 * Cleanup all active damage texts and status labels.
 * Should be called when transitioning between scenes to prevent orphaned text objects.
 */
export function clearAllDamageTexts() {
  activeDamageTexts.forEach((dt) => {
    try {
      dt.textObj.destroy();
    } catch (error) {
      // Text may already be destroyed, ignore
    }
  });
  activeDamageTexts = [];
}
